import { App, Router } from 'pylevate-runtime';
import { Chat } from './pages/chat.js';
import { Account } from './pages/account.js';
import { Keys } from './pages/keys.js';
export let app = new App({router: new Router([['/', Chat], ['/p/:id', Chat], ['/account', Account], ['/keys', Keys]])});
app.mount('#app');